export const PROVINCE = ["AREZZO", "BOLOGNA", "FIRENZE", "PRATO"];

export const COMUNI = [
  "Arezzo", "Bagno a Ripoli", "Bologna", "Campi Bisenzio", "Capolona", "Castiglion Fibocchi",
  "Castiglion Fiorentino", "Cavriglia", "Civitella in Val di Chiana", "Dicomano", "Empoli",
  "Figline e Incisa Valdarno", "Firenze", "Impruneta", "Lastra a Signa", "Laterina Pergine Valdarno",
  "Loro Ciuffenna", "Monterchi", "Montevarchi", "Pelago", "Pontassieve", "Prato", "Rignano Sull'Arno",
  "Rufina", "San Giovanni Valdarno", "Scandicci", "Sesto Fiorentino", "Terranuova Bracciolini",
];

export const CATEGORIE = ["Residenziale", "Terreni e aziende agricole"];
export const CONTRATTI = ["Vendita", "Affitto"];

export const ORDINI = [
  { v: "rilevanza", l: "Rilevanza" },
  { v: "recenti", l: "Data inserimento" },
  { v: "prezzo_asc", l: "Prezzo (crescente)" },
  { v: "prezzo_desc", l: "Prezzo (decrescente)" },
  { v: "mq_desc", l: "Mq" },
];

export const AGENZIE = [
  { id: "campo-di-marte", nome: "IVCasa Campo di Marte", indirizzo: "Via Francesco De Sanctis 32/34r", citta: "Firenze" },
  { id: "centro-storico", nome: "IVCasa Centro Storico", indirizzo: "Via Masaccio, 62", citta: "Firenze" },
  { id: "incisa", nome: "IVCasa Incisa Valdarno", indirizzo: "Viale XX Settembre 23", citta: "Incisa Valdarno" },
  { id: "reggello", nome: "IVCasa Reggello", indirizzo: "Via Gramsci 10", citta: "Reggello" },
  { id: "novoli", nome: "IVCasa Novoli", indirizzo: "Via Baracca 28/e/r", citta: "Firenze" },
  { id: "rignano", nome: "IVCasa Rignano", indirizzo: "Via dell'Unità Italiana, 8", citta: "Rignano sull'Arno" },
];

export const CONTATTI = {
  tel1: "055 9367109",
  tel2: "327 7816874",
  telSede: "342 3202755",
  ragione: "IVHOLDING SRL",
  piva: "07407130488",
  sede: "Viale dei Mille 59, 50131 Firenze (FI)",
  rea: "FI-667997",
};

export const TIPOLOGIE = [
  {
    slug: "ivaffitti",
    nome: "IVAffitti",
    img: "/img/ivcasa-affitti.png",
    claim: "Locazioni residenziali e commerciali",
    intro:
      "IVAFFITTI è il ramo dell'azienda che si occupa di gestire le locazioni residenziali e commerciali in tutta l'area coperta dalle nostre agenzie. Grazie all'esperienza maturata, siamo in grado di offrirvi un servizio accurato che comprende:",
    punti: [
      "Ricerca accurata del conduttore",
      "Accompagnamento dei clienti interessati all'immobile",
      "Consulenza e assistenza",
      "Redazione del contratto di locazione",
      "Registrazione del contratto di locazione",
      "Rinnovi delle registrazioni annuali",
      "Gestione del rapporto fra proprietario ed inquilino",
    ],
  },
  {
    slug: "ivservizi",
    nome: "IVServizi",
    img: "/img/ivcasa-servizi.png",
    claim: "Amministrazione, dati di mercato, persone",
    intro:
      "I.V SERVIZI è la struttura dove si è centralizzata l'amministrazione dell'azienda e che si occupa di supportare le agenzie in ogni loro esigenza. Un altro servizio che viene svolto all'interno di IV SERVIZI è la raccolta periodica di tutti i dati delle agenzie del gruppo così da creare report attendibili e dati di mercato estremamente precisi. Inoltre è qui che viene gestito il reclutamento e l'inserimento del personale.",
    punti: [],
  },
  {
    slug: "ivcall",
    nome: "IVCall",
    img: "/img/ivcasa-ivcall.png",
    claim: "Banca dati e matching in tempo reale",
    intro:
      "Nata nel 2020, IVCALL è la divisione aziendale che si occupa di gestire la banca dati del gruppo e di fornire supporto informatico e commerciale alle filiali sul territorio. Grazie ad un sistema gestionale da noi progettato e realizzato da un'azienda informatica di alto livello, IVCALL aggiorna in tempo reale il censimento dei potenziali acquirenti e venditori, in modo da fornire ai nostri agenti uno screening costante e completo delle opportunità offerte dal mercato immobiliare nei loro territori di competenza. Grazie ad IVCALL siamo in grado di evadere migliaia di operazioni di matching ogni giorno, mantenendo IVCASA in contatto con un milione di potenziali clienti in tutta la Toscana.",
    punti: [],
  },
];

export const BANNERS = [
  "/img/ivcasa-famiglia-sul-divano-con-scritte.jpg",
  "/img/ivcasa-coppia-chiavi-di-casa-con-scritte.jpg",
  "/img/iv-casa-famiglia-trasloco-con-scritte.jpg",
  "/img/ivcasa-coppia-che-balla-in-casa-con-scritte.jpg",
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Dove siamo", to: "/dove-siamo" },
  { label: "IVAffitti", to: "/ivaffitti" },
  { label: "IVServizi", to: "/ivservizi" },
  { label: "IVCall", to: "/ivcall" },
  { label: "Lavora con noi", to: "/lavora-con-noi" },
  { label: "Contatti", to: "/contatti" },
];

export const SOCIAL = {
  facebook: "https://www.facebook.com/ivcasagruppoimmobiliare",
  instagram: "https://www.instagram.com/ivcasa_gruppo_immobiliare/",
};

export const CHI_SIAMO = [
  { h: null, p: ["Una rete fatta di persone", "IVCASA è il gruppo immobiliare proprietario più esteso in Toscana.", "15 uffici, più di 300 compravendite mediate ogni anno. Ma soprattutto, IVCASA è una comunità di oltre 50 persone che lavorano ogni giorno fianco a fianco per offrire ai propri clienti il miglior servizio di mediazione possibile."] },
  { h: "Giovani", p: ["L'età media dei nostri agenti e collaboratori è di 30 anni.", "Crediamo che freschezza, entusiasmo e informalità nel rapporto con il cliente possano convivere con la massima professionalità del servizio. Formiamo direttamente le nostre persone e costruiamo insieme a loro un percorso di crescita professionale e personale."] },
  { h: "Completi", p: ["Un unico gruppo, dalla mediazione a tutto ciò che viene dopo.", "Accompagniamo il cliente nella compravendita, fino al rogito e nel post-vendita: pratiche tecniche, mutui e finanziamenti, ristrutturazioni e cambio utenze. Una rete di aziende convenzionate completa il servizio con traslochi, ristrutturazioni, arredamento e cucine."] },
  { h: "In crescita", p: ["Ogni anno apriamo da 2 a 5 nuovi uffici.", "Ma la crescita di cui siamo più orgogliosi non si misura soltanto in sedi e numeri. Nel mondo IVCASA sono nate amicizie, carriere e famiglie. Oggi crescono con noi tanti bellissimi bambini.", "E non vediamo l'ora di abbracciarne altri."] },
];

export const SEDI = [
  { nome: "IVCASA BOLOGNA", indirizzo: "Via Saragozza 7", citta: "Bologna", referente: "Samuele Ledda", tel: ["338 3829975", "051 9985888", "327 7053195"], email: "bologna@ivcasa.it" },
  { nome: "IVCASA GAVINANA", indirizzo: "Via di Ripoli 207 L", citta: "Firenze", referente: "Samuele Ledda", tel: ["338 3829975", "055 601691", "392 9819109"], email: "gavinana@ivcasa.it" },
  { nome: "IVCASA CAMPO DI MARTE-MASACCIO", indirizzo: "Via De Sanctis 32", citta: "Firenze", referente: "Santi Ramaj", tel: ["366 6720647", "055 9367109", "327 7816874"], email: "bellariva@ivcasa.it" },
  { nome: "IVCASA CENTRO STORICO", indirizzo: "Via Masaccio 62", citta: "Firenze", referente: "Francesco Benedetti", tel: ["393 9596375", "055 9367109", "327 7816874"], email: "firenzecentro@ivcasa.it" },
  { nome: "IVCASA RIFREDI", indirizzo: "Via Celso 3R", citta: "Firenze", referente: "Gian Marco Matteoli", tel: ["392 9817671", "055 5272174", "338 8714715"], email: "rifredi@ivcasa.it" },
  { nome: "IVCASA NOVOLI", indirizzo: "Via Baracca 28/er", citta: "Firenze", referente: "Simone Terranegra", tel: ["331 1345756", "055 3872293", "329 9455715"], email: "novoli@ivcasa.it" },
  { nome: "IVCASA ISOLOTTO", indirizzo: "Via Torcicoda 105R", citta: "Firenze", referente: "Valentina Miele", tel: ["333 1808350", "055 7711197"], email: "isolotto@ivcasa.it" },
  { nome: "IVCASA SESTO FIORENTINO", indirizzo: "", citta: "Sesto Fiorentino", referente: "", tel: ["055 5272174", "338 8714715"], email: "sestofiorentino@ivcasa.it" },
  { nome: "IVCASA SCANDICCI", indirizzo: "", citta: "Scandicci", referente: "", tel: ["055 7711197", "333 1808350"], email: "scandicci@ivcasa.it" },
  { nome: "IVCASA CAMPI BISENZIO", indirizzo: "", citta: "Campi Bisenzio", referente: "", tel: ["055 3872293", "329 9455715"], email: "campibisenzio@ivcasa.it" },
  { nome: "IVCASA VALDARNO", indirizzo: "Piazza della Libertà 1", citta: "Valdarno", referente: "Martina Airato", tel: ["338 9472394"], email: "valdarno@ivcasa.it" },
  { nome: "IVCASA AREZZO", indirizzo: "Via Petrarca 33B", citta: "Arezzo", referente: "Danny Paolini", tel: ["389 4738266", "338 9472394"], email: "arezzo@ivcasa.it" },
  { nome: "IVCASA VALDISIEVE / MUGELLO", indirizzo: "Via Fratelli Cervi 90", citta: "Pontassieve", referente: "Matteo Gaudenzi", tel: ["342 584286", "055 6146035", "344 0248617"], email: "pontassieve@ivcasa.it" },
  { nome: "IVCASA PRATO", indirizzo: "Via Francesco Ferrucci 339/31", citta: "Prato", referente: "Giorgio Soldi", tel: ["345 2412927"], email: "" },
  { nome: "IVCASA LASTRA A SIGNA", indirizzo: "Piazza 4 Novembre 8", citta: "Lastra a Signa", referente: "Aldo Sulejmani", tel: ["333 8844928"], email: "" },
  { nome: "IVCASA AFFITTI 1", indirizzo: "Via Giovanni dalle Bande Nere 4", citta: "Firenze", referente: "Alice Avella", tel: ["335 7369166"], email: "affitti@ivcasa.it" },
  { nome: "IVCASA AFFITTI 2", indirizzo: "Via Masaccio 62", citta: "Firenze", referente: "Federica Alterini", tel: ["342 3202755"], email: "" },
  { nome: "IVCASA AFFITTI 3", indirizzo: "Via Cervi 92 - Sede centrale", citta: "Pontassieve", referente: "", tel: [], email: "" },
  { nome: "FIRENZE CITTÀ", indirizzo: "", citta: "Firenze", referente: "", tel: ["393 9596375"], email: "renimmobiliare@ren.it" },
];

export const LAVORI = [
  { t: "Agente immobiliare", d: "Acquisizione e Gestione del portafoglio immobiliare dell'agenzia, creazione e sviluppo di team operativi, gestione di una filiale IVCASA. Richiesta comprovata esperienza nel settore immobiliare, disponibilità a lavorare per obiettivi, titolo abilitativo regolarmente conseguito." },
  { t: "Collaboratore esperto", d: "Gestione delle pubbliche relazioni per conto di IVCASA in una specifica area geografica, raccolta dati e creazione di contatti funzionali all'acquisizione del portafoglio immobiliare, attività di presentazione degli immobili ai potenziali acquirenti, affiancamento all'agente immobiliare nello svolgimento delle sue mansioni." },
  { t: "Collaboratore junior", d: "Percorso professionale di specializzazione nello sviluppo delle informazioni, nell'acquisizione del portafoglio immobiliare e nella gestione dei clienti IVCASA." },
  { t: "Coordinatrice", d: "Marketing e Web Marketing, Front Office, gestione delle informazioni in ingresso e in uscita dalla filiale. Supporto commerciale di vendita, segretariato." },
  { t: "Operatore IVCall", d: "Il profilo opererà nella divisione aziendale IVCALL, si occuperà di ricerche di mercato, gestione ed aggiornamento del portafoglio commerciale di IVCASA." },
];

export const mapsUrl = (a) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${a.indirizzo}, ${a.citta}`)}`;
